<template>
  <div class="social-share">
    <div class="social-share-link">
      <div class="title">
        {{ shareLinkLabel }}
      </div>
      <div class="link">
        <input id="shareLinkInput" ref="shareLinkInput" v-model="shareLink" type="text">
        <div v-if="shareLinkCopied" class="copy-btn" @click="copyShareLink">
          <!-- {{ $t('COMMON.COPIED') }} -->
          <i class="material-icons done">
            done
          </i>
        </div>
        <div v-else class="copy-btn" @click="copyShareLink">
          {{ $t('COMMON.COPY') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SocialShareLink',
  components: {},
  props: {
    shareLink: {
      type: String,
      default: `${window.location.protocol}//${window.location.host}${window.location.pathname}`
    },
    shareLinkLabel: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      shareLinkCopied: false
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    copyShareLink() {
      if (!this.shareLink) {
        this.shareLink = this.shareLink()
      }
      this.$refs.shareLinkInput.select()
      // this.$refs.shareLinkInput.focus()
      this.$refs.shareLinkInput.setSelectionRange(0, this.shareLink.length)
      const successful = document.execCommand('copy')
      if (successful) {
        this.shareLinkCopied = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.social-share {
  &-link {
    .title {
      margin-bottom: 8px;
      font-size: 12px;
      font-weight: 500;
      color: $grey-7d;
    }
    .link {
      height: 46px;
      border-radius: 4px;
      background-color: #ffffff;
      border: solid 1px #ececec;
      input {
        float: left;
        display: inline-block;
        vertical-align: top;
        height: 44px;
        width: calc(100% - 128px);
        padding: 9px 16px;
        font-size: 16px;
        font-weight: 700;
        color: $grey-9b;
        caret-color: $theme-yellow;
        outline: none;
        border: none;
      }
      input::selection {
        background-color: rgba(244, 185, 59, 0.28);
        // color: $grey-9b;
      }
      .copy-btn {
        float: left;
        display: inline-block;
        vertical-align: top;
        height: 44px;
        width: 128px;
        line-height: 44px;
        font-size: 16px;
        font-weight: 700;
        color: $grey-9b;
        text-align: center;
        border-left: solid 1px #ececec;
        outline: none;
        cursor: pointer;
        .done {
          line-height: 44px;
        }
      }
    }
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {
  .social-share {
    &-link {
      .title {
        display: none;
      }
      .link {
        input {
          width: calc(100% - 64px);
        }
        .copy-btn {
          width: 64px;
        }
      }
    }
  }
}
</style>
